var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "div",
            { staticStyle: { "padding-bottom": "18px" } },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  staticClass: "search-form",
                  attrs: { inline: true, model: _vm.searchForm, size: "small" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单编号", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入订单编号" },
                        model: {
                          value: _vm.searchForm.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderNo", $$v)
                          },
                          expression: "searchForm.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称", prop: "goodsName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入商品名称" },
                        model: {
                          value: _vm.searchForm.goodsName,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "goodsName", $$v)
                          },
                          expression: "searchForm.goodsName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "类型", prop: "type" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择类型",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "type", $$v)
                            },
                            expression: "searchForm.type",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "下单", value: "1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "退款", value: "2" },
                          }),
                          _c("el-option", {
                            attrs: { label: "取消", value: "3" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择状态",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "status", $$v)
                            },
                            expression: "searchForm.status",
                          },
                        },
                        [
                          _vm._l(_vm.brandList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          _c("el-option", {
                            attrs: { label: "待审核", value: "1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已扣除", value: "2" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已退回", value: "3" },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间", prop: "updatedTimeStart" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy - MM - dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.value1,
                          callback: function ($$v) {
                            _vm.value1 = $$v
                          },
                          expression: "value1",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("search")
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("reset")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "title" }, [
          _c("h3", [_vm._v("列表数据")]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-upload2",
                    loading: _vm.exporting,
                  },
                  on: { click: _vm.exportFreezeList },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { attrs: { id: "base-list" } },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: "'always'",
                },
              ],
              attrs: {
                column: _vm.columns,
                data: _vm.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50],
                "current-page": _vm.page.currentPage,
                "page-size": _vm.page.pageSize,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "selection-change": _vm.onMultipleSelection,
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }